import { render, staticRenderFns } from "./addfbLicense.vue?vue&type=template&id=4f23b3da&"
import script from "./addfbLicense.vue?vue&type=script&lang=js&"
export * from "./addfbLicense.vue?vue&type=script&lang=js&"
import style0 from "./addfbLicense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports